module.exports = __webpack_public_path__ + "static/media/HCMM178.074aa85a.jpg";